import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-slate-100">
          <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-6 text-center">
            <h1 className="text-lg font-semibold text-slate-800 mb-2">Algo deu errado</h1>
            <p className="text-sm text-slate-600 mb-4">
              A página não pôde carregar. Abra o Console do navegador (F12) para mais detalhes.
            </p>
            <button
              type="button"
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-4 py-2 bg-slate-800 text-white rounded-lg text-sm"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
